<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-sm-8">
        <h2>{{ title }}</h2>
        <ol class="breadcrumb">
          <li v-for="(item, itemKey) in path" :key="itemKey">
            <a @click.prevent="go(item.link)" v-if="item.link">{{ item.title }}</a>
            <span>{{ item.title }}</span>
          </li>
          <li class="active">
            <!-- <strong>{{ action }}</strong> -->
          </li>
        </ol>
      </div>
      <div class="col-sm-4">
        <div class="title-action" v-if="isVisible">
          <button class="btn btn-w-m btn-success"
            @click="navigate(btnTxt, btnLink)">
            <!-- {{ btnTxt }} -->
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: ["title", "action", "btnTxt", "btnLink"],
  data() {
    return {
      title: '',
      action: null,
      btnTxt: '',
      btnLink: '',
      path: [],
      isVisible: this.btnTxt && this.btnLink
    };
  },
  watch: {
    '$route.meta.breadcrumb' () {
      this.setBreadcrumb()
    }
  },
  methods: {
    setBreadcrumb() {
      const breadcrumbInfo = this.$route.meta.breadcrumb
      this.title = breadcrumbInfo.title

      this.path = breadcrumbInfo.paths.map(item => item)
    },
    navigate(btnTxt, btnLink) {
      if (btnTxt === "Voltar") {
        this.$router.push({ path: btnLink });
        return;
      }
      this.$router.push({ path: btnLink });
    },

    go(item) {
      if (item.path === this.$route.path) {
        this.$router.push({
          path: item.path,
          query: this.$route.query,
          params: this.$route.params
        });
      } else {
        this.$router.push(item.path);
      }
    },

    pathName(path) {
      return path.meta.breadcrump || path.path.substr(1);
    }
  },
  mounted() {
    this.setBreadcrumb()
  }
};
</script>

<style scoped>
.breadcrumb li:hover {
  font-weight: bold;
}
</style>
